import { useEffect } from "react";
import { c } from "../lib/theme";

export function Toast({ text, onDone }: { text: string; onDone: () => void }) {
  useEffect(() => { const t = setTimeout(onDone, 2600); return () => clearTimeout(t); }, [onDone]);
  return (
    <div style={{ position: "fixed", bottom: 22, left: "50%", transform: "translateX(-50%)", background: c.panel, border: `1px solid ${c.line2}`, color: c.textHi, padding: "10px 18px", borderRadius: 8, fontSize: 14.5, zIndex: 50 }}>
      {text}
    </div>
  );
}
